module.exports = __webpack_public_path__ + "img/smoke-impacted.5b752f80.svg";